import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

const Footer = ({ user }) => {
  const isAdmin = !!user && (
    user.is_admin === true ||
    user.role === 'admin' ||
    user.role === 'super_admin' ||
    user.admin_role === 'admin' ||
    user.admin_role === 'super_admin'
  );
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-black/5 dark:border-white/10 bg-white dark:bg-[#0A0A0A]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-6">
          <div>
            <div className="text-xl font-black tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>
              <span className="text-[#FF3B30]">LIVE</span>
              <span className="text-black dark:text-white">MOA</span>
            </div>
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">모든 라이브를 한 곳에</p>
          </div>

          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-gray-600 dark:text-gray-400" aria-label="Footer navigation">
            <Link to="/schedule" className="hover:text-[#FF3B30] transition-colors" data-testid="footer-schedule">스케줄</Link>
            <Link to="/search" className="hover:text-[#FF3B30] transition-colors" data-testid="footer-search">판매자 찾기</Link>
            <Link to="/terms" className="hover:text-[#FF3B30] transition-colors" data-testid="footer-terms">이용약관</Link>
            <Link to="/privacy" className="hover:text-[#FF3B30] transition-colors font-medium" data-testid="footer-privacy">개인정보처리방침</Link>
          </nav>
        </div>

        <div
          className="mt-6 pt-5 border-t border-black/5 dark:border-white/10 text-[11px] leading-6 text-gray-500 dark:text-gray-500"
          data-testid="footer-business-info"
        >
          <div className="font-semibold text-gray-700 dark:text-gray-300 mb-1">엠지컴퍼니 (LIVEMOA · 라이브모아)</div>
          <div>대표자: 김현민 · 사업자등록번호: 685-18-02463</div>
          <div>통신판매업 신고번호: 제2025-인천서구-3628호</div>
          <div>주소: 인천광역시 서구 중봉대로612번길 16, 13층 1306호 (청라동, 서후센타시아)</div>
          <div>
            고객문의:{' '}
            <a href="mailto:k615745@naver.com" className="hover:text-[#FF3B30] transition-colors" data-testid="footer-email">
              k615745@naver.com
            </a>{' '}
            · 010-6744-6344
          </div>
        </div>

        {isAdmin && (
          <div
            className="mt-6 pt-4 border-t border-dashed border-black/10 dark:border-white/10"
            data-testid="footer-admin-area"
          >
            <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#FF3B30] mb-2">
              <ShieldCheck size={12} />
              관리자 전용
            </div>
            <nav className="flex flex-wrap gap-x-5 gap-y-2 text-xs" aria-label="Admin footer navigation">
              <Link
                to="/admin"
                className="text-gray-700 dark:text-gray-300 hover:text-[#FF3B30] transition-colors font-medium"
                data-testid="footer-admin-dashboard"
              >
                관리자
              </Link>
              <Link
                to="/admin/seller-applications"
                className="text-gray-700 dark:text-gray-300 hover:text-[#FF3B30] transition-colors font-medium"
                data-testid="footer-admin-applications"
              >
                신청관리
              </Link>
            </nav>
          </div>
        )}

        <p className="mt-6 text-[11px] text-gray-400 dark:text-gray-600">
          © {year} LIVEMOA. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
